export default function About() {
  return (
    <main className="container">
      <h1>About JobLink</h1>

      <p>
        <strong>JobLink</strong> is a career support platform designed to help
        job seekers find suitable employment opportunities through guidance,
        preparation, and professional support.
      </p>

      <p>
        Many applicants struggle not because they lack skills, but because they
        lack proper CVs, interview preparation, and access to job opportunities.
        JobLink bridges this gap by supporting applicants from application to
        interview readiness.
      </p>

      <h2>What We Do</h2>
      <ul>
        <li>Collect and review submitted CVs</li>
        <li>Update or create professional CVs</li>
        <li>Search and apply for suitable jobs on behalf of applicants</li>
        <li>Train applicants on interview preparation</li>
        <li>Provide structured job-hunting support</li>
      </ul>

      <h2>How It Works</h2>
      <ol>
        <li>Applicants submit their CV and application</li>
        <li>An auto-response email is sent with instructions</li>
        <li>Applicants submit proof of payment and CV</li>
        <li>JobLink reviews or creates the CV</li>
        <li>We begin job hunting and interview preparation</li>
      </ol>

      <h2>Our Goal</h2>
      <p>
        Our goal is to reduce unemployment stress by helping applicants present
        themselves professionally and prepare confidently for interviews.
      </p>
    </main>
  );
}